import type { PageBlockDefinition } from '../definition-types'

export const heroOverlayDefinition: PageBlockDefinition = {
  type: 'hero-overlay',
  label: 'Hero Overlay',
  description: 'Large visual hero with a full-bleed lead image and optional secondary story slots in a right overlay panel.',
  rowCompatible: true,
  columnCompatible: false,
  category: 'editorial',
  minArticles: 1,
  maxArticles: 3,
  slots: [
    { name: 'lead', label: 'Lead Story', required: true },
    { name: 'secondary-1', label: 'Secondary Story 1', required: false },
    { name: 'secondary-2', label: 'Secondary Story 2', required: false },
  ],
  defaultConfig: {
    showRightOverlay: true,
    overlayIntensity: 'medium',
    showSummary: true,
  },
  editorFields: [
    { key: 'showRightOverlay', label: 'Show Right Overlay', type: 'toggle' },
    {
      key: 'overlayIntensity',
      label: 'Overlay Intensity',
      type: 'select',
      options: [
        { label: 'Low', value: 'low' },
        { label: 'Medium', value: 'medium' },
        { label: 'High', value: 'high' },
      ],
    },
    { key: 'showSummary', label: 'Show Summary', type: 'toggle' },
  ],
}
